"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const styles_1 = require("@material-ui/core/styles");
const classnames_1 = require("classnames");
const package_1 = require("../package");
const ArcadeHeader = ({ className, classes, title, subTitle, balance, onNavigate, navigateToBuyScreen, navigateToHistory, isLoggedIn, disableHistoryButton }) => ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: (0, classnames_1.default)(className, classes.header) }, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.detailHeader }, { children: [(0, jsx_runtime_1.jsx)(core_1.Tooltip, Object.assign({ title: `Lucky Lounge` }, { children: (0, jsx_runtime_1.jsx)(core_1.Link, Object.assign({ onClick: onNavigate, component: 'a', "aria-label": `Go back to Games list`, className: classes.backButton }, { children: (0, jsx_runtime_1.jsxs)(core_1.Typography, Object.assign({ variant: "body2", color: "textPrimary", className: classes.centered }, { children: ['Lucky Lounge', " ", (0, jsx_runtime_1.jsx)(package_1.Icon, { iconType: 'material', iconName: 'chevron_right' })] })) })) })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ mdUp: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h6", component: 'h1', color: "textPrimary" }, { children: title })) })), (0, jsx_runtime_1.jsx)(core_1.Hidden, Object.assign({ smDown: true }, { children: (0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ variant: "h4", component: 'h1', color: "textPrimary" }, { children: title })) })), subTitle ? ((0, jsx_runtime_1.jsx)(core_1.Typography, Object.assign({ color: "primary", variant: "overline", className: classes.subTitle }, { children: subTitle }))) : null] })), isLoggedIn ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.points }, { children: (0, jsx_runtime_1.jsx)(package_1.ArcadePointsSection, { balance: balance, onClick: navigateToBuyScreen, navigateToHistory: navigateToHistory, disableHistoryButton: disableHistoryButton }) }))) : ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.points }, { children: (0, jsx_runtime_1.jsx)(package_1.ArcadePointsSection, { balance: balance, onClick: navigateToBuyScreen, navigateToHistory: navigateToHistory, disableHistoryButton: true, disableBalance: true }) })))] })));
const styles = (theme) => (0, core_1.createStyles)({
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            alignItems: 'center'
        }
    },
    detailHeader: {
        alignItems: 'start',
        display: 'flex',
        flexDirection: 'column',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        }
    },
    backButton: {
        cursor: 'pointer',
        '&:hover': {
            textDecoration: 'none'
        }
    },
    centered: {
        display: 'flex',
        justifyContent: 'center'
    },
    points: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    subTitle: {
        marginTop: theme.spacing()
    },
    historyIcon: {
        color: theme.palette.secondary.main,
        marginRight: theme.spacing()
    }
});
exports.default = (0, styles_1.withStyles)(styles)(ArcadeHeader);
//# sourceMappingURL=ArcadeHeader.js.map